// @ts-nocheck

import { shouldReduceMotion } from '@theme/utilities';

const TRANSITION_DURATION_MS = 250;

/**
 * @param {HTMLDetailsElement} details
 * @param {boolean} expanded
 */
function setAccordionExpanded(details, expanded) {
  details.dataset.expanded = expanded ? 'true' : 'false';
}

/**
 * @param {HTMLDetailsElement} details
 */
function initAccordion(details) {
  if (details.dataset.accordionReady) return;
  details.dataset.accordionReady = 'true';

  const summary = details.querySelector('summary.accordion-snippet__trigger');
  const content = details.querySelector('.accordion-snippet__content');

  if (!summary || !content) return;

  setAccordionExpanded(details, details.open);

  summary.addEventListener('click', (event) => {
    event.preventDefault();

    const willOpen = !details.open;
    setAccordionExpanded(details, willOpen);

    if (details.open) {
      closeAccordion(details, content);
    } else {
      openAccordion(details, content);
    }
  });
}

/**
 * @param {HTMLDetailsElement} details
 * @param {HTMLElement} content
 */
function openAccordion(details, content) {
  if (shouldReduceMotion()) {
    details.open = true;
    return;
  }

  details.classList.add('accordion-snippet--animating');
  details.open = true;
  content.style.height = '0px';
  content.style.transition = `height ${TRANSITION_DURATION_MS}ms ease`;

  requestAnimationFrame(() => {
    const height = content.scrollHeight;
    content.style.height = `${height}px`;
  });

  const end = () => {
    content.style.height = 'auto';
    content.style.transition = '';
    details.classList.remove('accordion-snippet--animating');
    content.removeEventListener('transitionend', end);
  };

  content.addEventListener('transitionend', end);
}

/**
 * @param {HTMLDetailsElement} details
 * @param {HTMLElement} content
 */
function closeAccordion(details, content) {
  if (shouldReduceMotion()) {
    details.open = false;
    return;
  }

  details.classList.add('accordion-snippet--animating');
  content.style.transition = `height ${TRANSITION_DURATION_MS}ms ease`;
  content.style.height = `${content.scrollHeight}px`;

  requestAnimationFrame(() => {
    content.style.height = '0px';
  });

  const end = () => {
    details.open = false;
    content.style.height = '';
    content.style.transition = '';
    details.classList.remove('accordion-snippet--animating');
    content.removeEventListener('transitionend', end);
  };

  content.addEventListener('transitionend', end);
}

document.querySelectorAll('details.accordion-snippet').forEach(initAccordion);
